// extracted by mini-css-extract-plugin
export default {"NumbersImage":"NumbersImage_NumbersImage__K2z4F","NumbersImage__img":"NumbersImage_NumbersImage__img__cirfW"};